module.exports = __webpack_public_path__ + "img/logo.95607cf7.svg";